import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Breadcrumbs as MagritteBreadcrumbs, BreadcrumbsItem } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { getProfessionsRouteHref, PROFESSIONS_ROUTE } from 'src/app/routesUtils';

const TrlKeys = {
    professions: 'career-platform.page-names.professions',
};

const Breadcrumbs: TranslatedComponent = ({ trls }) => {
    const { profession } = useSelectorNonNullable((state) => state.pageProfession);

    return (
        <MagritteBreadcrumbs>
            <BreadcrumbsItem Element={SPALink} to={PROFESSIONS_ROUTE} isSeoLink>
                {trls[TrlKeys.professions]}
            </BreadcrumbsItem>
            <BreadcrumbsItem
                Element={SPALink}
                to={getProfessionsRouteHref({ streamId: profession.stream.id })}
                isSeoLink
            >
                {profession.stream.name}
            </BreadcrumbsItem>
            <BreadcrumbsItem>{profession.name}</BreadcrumbsItem>
        </MagritteBreadcrumbs>
    );
};

export default translation(Breadcrumbs);
